import React, {useEffect} from 'react'
import {useTranslation} from "react-i18next";
import {Typography} from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";
import {getCurrentLanguage} from "../../utils/Helpers";
const soilTypes = require("../../data/soil_types.json")

const InfoPageSoilTypeLayout = () =>{
    const {t,i18n} = useTranslation()
    const dispatch = useAppDispatch();
    let key = getCurrentLanguage(i18n);
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/info/soil-type",
            type:"pageView"
        }))
    });

    const createTableHeader = () =>{
        let component:any  = []
        if(soilTypes && key){
            soilTypes[key].forEach((s:any ) => {
                component.push(
                    <TableCell align="center">{s.name}</TableCell>
                )
            })
        }
        return component
    }
    const createFieldCapacity = () =>{
        let component:any  = []
        if(soilTypes && key){
            soilTypes[key].forEach((s:any ) => {
                component.push(
                    <TableCell align="center">{s.field_capacity}</TableCell>
                )
            })
        }
        return component
    }

    const createWiltingPoint = () =>{
        let component:any  = []
        if(soilTypes && key){
            soilTypes[key].forEach((s:any ) => {
                component.push(
                    <TableCell align="center">{s.wilting_point}</TableCell>
                )
            })
        }
        return component
    }

    return (
        <div>
            <Typography style={{textAlign: "center"}} variant="h3" gutterBottom>
                {t('info_page.soil_type.title' as any)}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
                {t('info_page.soil_type.subtitle' as any)}
            </Typography>
            <br/>

            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell> {t('info_page.soil_type.title' as any)}</TableCell>
                            {createTableHeader()}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell> {t('info_page.soil_type.field_capacity' as any)} [vol%]</TableCell>
                            {createFieldCapacity()}
                        </TableRow>
                        <TableRow>
                            <TableCell>{t('info_page.soil_type.wilting_point' as any)}  [vol%]</TableCell>
                            {createWiltingPoint()}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <br/>
            <Typography variant="body1" gutterBottom>
               <b> {t('info_page.soil_type.field_capacity' as any)}:</b> {t('info_page.soil_type.field_capacity_description' as any)}
                <br/>
                <b>Permanent {t('info_page.soil_type.wilting_point' as any)}:</b> {t('info_page.soil_type.wilting_point_description' as any)}
            </Typography>
        </div>
    )
}
export default InfoPageSoilTypeLayout
